import api from '../api';
import { queryToString } from 'helpers/AppHelpers';

export const getRequestsListApi = (q) =>
  api.get(`/MaintenanceRequests?${queryToString(q)}`).then((res) => res.data);

export const getCreationFromApi = (q) =>
  api.get(`/MaintenanceRequest/CreationForm?${queryToString(q)}`).then((res) => res.data);

export const getRequestApi = (id) =>
  api.get(`/MaintenanceRequest?id=${id}`).then((res) => res.data);

export const createRequestApi = (params) =>
  api.post(`/MaintenanceRequest`, params).then((res) => res.data);

export const updateRequestApi = (params) =>
  api.put(`/MaintenanceRequest`, params).then((res) => res.data);

export const deleteRequestApi = (id) =>
  api.delete(`/MaintenanceRequest?id=${id}`).then((res) => res.data);
